import React from 'react';

import { ConnectionState } from './types';
import Body from '../../../../atomic/atoms/Body';
import Button from '../../../../atomic/atoms/Button';
import SVGIcon from '../../../../atomic/atoms/SVGIcon';
import { Flex } from '../../../../Utils/styles/display';
import useConnectionsController from './useConnectionsController';
import { SHARE_SHEET_EVENTS } from '../../../../Utils/analytics/constants';
import useOpenSlackModal from '../../../../atomic/organism/ConnectToSlack/useOpenSlackModal';
import SlackWorkspaceStateButton from '../../../../atomic/molecules/SlackWorkspaceStateButton';
import SlackWorkspaceAndChannelsSelector from '../../../../atomic/molecules/SlackWorkspaceAndChannelsSelector';

import {
  Container,
  ActiveBadge,
  SlackContainer,
  TeamsContainer,
  DisconnectedBadge,
  StyledConnectToSlackButton,
} from './styles';
import { trackShareSheetActionEvent } from '../../../../Utils/analytics/shareSheet';

const ConnectionsController = () => {
  const { open } = useOpenSlackModal();

  const {
    state,
    setState,
    channelList,
    flowDetails,
    connectionsList,
    showSavedButton,
    connectionStatus,
    deleteConnection,
    isLoadingChannels,
    selectedConnection,
    isSavingConnection,
    isLoadingConnections,
    isDeletingConnection,
    setSelectedConnection,
    selectedPeopleToPostChannel,
    setSelectedPeopleToPostChannel,
    selectedPostFlowResponseChannel,
    setSelectedPostFlowResponseChannel,
  } = useConnectionsController();

  return (
    <Container>
      <>
        <Body variant="body1Medium" color="gray9">
          Connect this flow to your other apps
        </Body>
        <Body variant="body2" color="gray9">
          Send notifications and posts to specific channels to engage teammates
          where they work.
        </Body>
        <SlackContainer>
          <Flex justifyContent="space-between">
            <Flex>
              <SVGIcon icon="slack-logo" />
              {connectionStatus === 'CONNECTED' && (
                <ActiveBadge>
                  <Body variant="body3" color="geekBlue8">
                    Active
                  </Body>
                </ActiveBadge>
              )}
              {connectionStatus === 'DISCONNECTED' && (
                <DisconnectedBadge>
                  <Body variant="body3" color="dustRed7">
                    Connection Broken
                  </Body>
                </DisconnectedBadge>
              )}
            </Flex>
            <SlackWorkspaceStateButton
              state={state}
              onStateChange={setState}
              showSavedButton={showSavedButton}
              connectionsList={connectionsList}
              selectedConnection={selectedConnection}
              isSavingConnection={isSavingConnection}
              onSelectedConnectionChange={setSelectedConnection}
            />
          </Flex>

          {state === ConnectionState.ConnectToSlackState && (
            <>
              <Body variant="body2Medium" color="gray9">
                Connect your Slack to get started
              </Body>
              <Body variant="body3" color="gray9">
                Once you do, choose channels to send reminders to post and posts
                to your teammates!
              </Body>
              <StyledConnectToSlackButton disabled={isLoadingConnections} />
            </>
          )}

          {(state === ConnectionState.ConnectionDisplayState ||
            state === ConnectionState.ConnectionEditState) && (
            <SlackWorkspaceAndChannelsSelector
              state={state}
              channelList={channelList}
              flowDetails={flowDetails}
              connectionsList={connectionsList}
              isLoadingChannels={isLoadingChannels}
              isSavingConnection={isSavingConnection}
              selectedConnection={selectedConnection}
              onConnectDifferentWorkspaceClick={open}
              onDisconnectSlackClick={() => {
                trackShareSheetActionEvent({
                  app: 'slack',
                  tab: 'connections',
                  action: SHARE_SHEET_EVENTS.SLACK_DISCONNECTED,
                });
                deleteConnection();
                setSelectedPeopleToPostChannel([]);
                setSelectedPostFlowResponseChannel([]);
                setState(ConnectionState.ConnectState);
              }}
              isDeletingConnection={isDeletingConnection}
              isLoadingConnections={isLoadingConnections}
              setSelectedConnection={setSelectedConnection}
              selectedPeopleToPostChannel={selectedPeopleToPostChannel}
              setSelectedPeopleToPostChannel={setSelectedPeopleToPostChannel}
              selectedPostFlowResponseChannel={selectedPostFlowResponseChannel}
              setSelectedPostFlowResponseChannel={
                setSelectedPostFlowResponseChannel
              }
            />
          )}
        </SlackContainer>

        <TeamsContainer>
          <SVGIcon icon="teams-logo" />

          <Button variant="text" icon="alarm" size="small">
            Notify Me
          </Button>
        </TeamsContainer>
      </>
    </Container>
  );
};

export default ConnectionsController;
